import React, { useState } from "react";
import { resetPasswordRequest } from "./auth";
import VerifyCode from "./VerifyCode";
import "./Login.css";
import { useTranslation } from "react-i18next";

function ResetPassword({ setIsResetPass }) {
  const { t } = useTranslation("login");
  const [email, setEmail] = useState("");
  const [resetLinkMessage, setResetLinkMessage] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validate = (value) => {
    const errs = {};
    if (!value.trim()) {
      errs.email = t("resetPassword.validation.emailRequired");
    } else if (
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
    ) {
      errs.email = t("resetPassword.validation.emailInvalid");
    }
    return errs;
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    setErrors(validate(e.target.value));
  };

  const handleBlur = () => {
    setTouched({ email: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(email);
    setErrors(validationErrors);
    setTouched({ email: true });
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    try {
      setLoading(true);
      setResetLinkMessage("");
      const response = await resetPasswordRequest({ email });
      if (response?.status === 200 || response?.status === 201) {
        setIsCodeSent(true);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.error ||
        error?.response?.message ||
        t("resetPassword.genericError");
      setResetLinkMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (isCodeSent) {
    return <VerifyCode setIsResetPass={setIsResetPass} email={email} />;
  }

  return (
    <>
      <h2 className="title-login">{t("resetPassword.title")}</h2>
      <p className="subtitle-login">{t("resetPassword.subtitle")}</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group-login">
          <label htmlFor="email">{t("resetPassword.labels.email")}</label>
          <input
            type="text"
            id="email"
            value={email}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`outline-none ${
              touched.email && (errors.email || resetLinkMessage)
                ? "border-red-400 border-2"
                : touched.email && !errors.email && !resetLinkMessage
                ? "border-green-400 border-2"
                : ""
            }`}
          />
          {touched.email && (errors.email || resetLinkMessage) && (
            <p className="my-1 text-sm font-medium text-red-600">
              {errors.email || resetLinkMessage}
            </p>
          )}
        </div>
        <div className="form-group-login">
          <button
            type="submit"
            disabled={loading || Object.keys(errors).length > 0 || !email}
            className={`login-btn ${
              Object.keys(errors).length > 0 || !email
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
          >
            {loading
              ? t("resetPassword.buttons.submitting")
              : t("resetPassword.buttons.submit")}
          </button>
        </div>
        <div className="form-group-login">
          <button
            className="text-white back-to-login"
            onClick={() => setIsResetPass(false)}
          >
            {t("resetPassword.buttons.backToLogin")}
          </button>
        </div>
      </form>
    </>
  );
}

export default ResetPassword;
